/**
 * The seven label types tracked in `book_labels.label_type`. This list is
 * the single source of truth on the frontend — filter rails, admin editors,
 * and onboarding screens all iterate over it so adding a new type is a
 * one-line change.
 */
export const LABEL_TYPES = [
  'genre',
  'topic',
  'reading_level',
  'interest_level',
  'historical_event',
  'time_period',
  'book_series',
] as const;

export type LabelType = (typeof LABEL_TYPES)[number];

/** Human-readable plural labels used in the filter rail and admin sidebar. */
export const LABEL_TYPE_TITLES: Record<LabelType, string> = {
  genre: 'Genres',
  topic: 'Topics',
  reading_level: 'Reading Levels',
  interest_level: 'Interest Levels',
  historical_event: 'Historical Events',
  time_period: 'Time Periods',
  book_series: 'Book Series',
};

/** Short singular labels used in inline text ("Add genre", "Edit topic"). */
export const LABEL_TYPE_SINGULAR: Record<LabelType, string> = {
  genre: 'genre',
  topic: 'topic',
  reading_level: 'reading level',
  interest_level: 'interest level',
  historical_event: 'historical event',
  time_period: 'time period',
  book_series: 'book series',
};
